import moment from 'moment';
import { AppUserRatingsFilters } from '../models/appUserRatingsModels';

export interface AppUserRatingsState {
  filters: AppUserRatingsFilters;
  page: number;
  rowsPerPage: number;
  sort: { sortDir: string; sortBy: string };
  lastAccessDate?: string;
}

const STORAGE_KEY = 'appUserRatingsState';

export const getDefaultFilters = (): AppUserRatingsFilters => ({
  dateFrom: moment().startOf('day'),
  dateTo: moment().endOf('day'),
  transfer_reservation_id: null,
  driver_id: null,
  score_min: null,
  score_max: null,
  client_id: null,
  client_type: 'AllClient'
});

export const getDefaultState = (): AppUserRatingsState => ({
  filters: getDefaultFilters(),
  page: 1,
  rowsPerPage: 10,
  sort: { sortDir: 'DESC', sortBy: 'created_at' }
});

const deserializeState = (stored: Partial<AppUserRatingsState>): AppUserRatingsState => {
  const today = moment().format('YYYY-MM-DD');
  const isNewDay = !stored.lastAccessDate || stored.lastAccessDate !== today;
  return {
    ...getDefaultState(),
    ...stored,
    filters: {
      ...getDefaultFilters(),
      ...(stored.filters || {}),
      dateFrom: isNewDay ? moment().startOf('day') : stored.filters?.dateFrom ? moment(stored.filters.dateFrom) : moment().startOf('day'),
      dateTo: isNewDay ? moment().endOf('day') : stored.filters?.dateTo ? moment(stored.filters.dateTo) : moment().endOf('day')
    },
    lastAccessDate: today
  };
};

export const loadAppUserRatingsState = (): AppUserRatingsState => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return deserializeState(JSON.parse(stored));
  } catch {}
  return getDefaultState();
};

export const saveAppUserRatingsState = (state: AppUserRatingsState): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      ...state,
      lastAccessDate: moment().format('YYYY-MM-DD')
    }));
  } catch {}
};
